import { multiSelectFilter, createActionsColumn, urlCell } from '../columnUtils';

export const createActiveDxGroupsColumns = (setSelectedItem, setDrawerVisible, handleDelete) => [
  {
    id: 'groupCode',
    header: 'Group Code',
    accessorKey: 'groupCode',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'displayName',
    header: 'Display Name',
    accessorKey: 'displayName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'points',
    header: 'Points',
    accessorKey: 'points',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'mdsSourceItem',
    header: 'MDS Source Item',
    accessorKey: 'mdsSourceItem',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceUrl',
    header: 'Source URL',
    accessorKey: 'sourceUrl',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  createActionsColumn(setSelectedItem, setDrawerVisible, handleDelete)
];
